// The backend allows quotation and custom model number actions to the drawing owner whatever their
// role (#1523); admins additionally reach other users' drawings.
export const canAccessQuotations = (userRole: string, drawingOwner: "me" | "other" | undefined) =>
	userRole === "Admin" || userRole === "Super Admin" || drawingOwner === "me"
